import React from 'react';
import { 
  Truck, 
  Clock, 
  CheckCircle, 
  AlertTriangle,
  TrendingUp,
  Calendar,
  Package,
  Ship
} from 'lucide-react';

const Dashboard = () => {
  const stats = [
    {
      name: 'En entrepôt',
      value: '24',
      change: '+12%',
      changeType: 'positive',
      icon: Truck,
      color: 'bg-atl-blue-500'
    },
    {
      name: 'En entrepôt douanier',
      value: '8',
      change: '-3%',
      changeType: 'negative',
      icon: Clock,
      color: 'bg-yellow-500'
    },
    {
      name: 'Livraisons terminées ce mois',
      value: '156',
      change: '+8%',
      changeType: 'positive',
      icon: CheckCircle,
      color: 'bg-atl-green-500'
    }
  ];

  const recentLivraisons = [
    {
      id: 'LIV-2024-001',
      client: 'CMA CGM',
      fournisseur: 'Maersk Line',
      date: '2024-01-15',
      status: 'En cours',
      poids: '2.5 tonnes',
      conditionnement: 'Conteneur'
    },
    {
      id: 'LIV-2024-002',
      client: 'MSC',
      fournisseur: 'Hapag-Lloyd',
      date: '2024-01-14',
      status: 'Terminée',
      poids: '1.8 tonnes',
      conditionnement: 'Palette'
    },
    {
      id: 'LIV-2024-003',
      client: 'Evergreen',
      fournisseur: 'ONE',
      date: '2024-01-13',
      status: 'En attente',
      poids: '3.2 tonnes',
      conditionnement: 'Conteneur'
    }
  ];

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-port-gray-900">Tableau de bord</h1>
          <p className="text-port-gray-600">Vue d'ensemble des activités ATL</p>
        </div>
        <div className="flex items-center space-x-2 text-port-gray-500">
          <Calendar className="h-5 w-5" />
          <span>{new Date().toLocaleDateString('fr-FR')}</span>
        </div>
      </div>

      {/* Statistiques */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.name} className="card p-6">
              <div className="flex items-center">
                <div className={`p-3 rounded-lg ${stat.color}`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-port-gray-600">{stat.name}</p>
                  <p className="text-2xl font-bold text-port-gray-900">{stat.value}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Graphiques et activités récentes */}
      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        {/* Activités récentes */}
        <div className="card p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-port-gray-900">Livraisons récentes</h3>
            <button className="text-atl-blue-600 hover:text-atl-blue-700 text-sm font-medium">
              Voir tout
            </button>
          </div>
          <div className="space-y-4">
            {recentLivraisons.map((livraison) => (
              <div key={livraison.id} className="flex items-center justify-between p-4 bg-port-gray-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <Package className="h-5 w-5 text-atl-blue-600" />
                  <div>
                    <p className="font-medium text-port-gray-900">{livraison.id}</p>
                    <p className="text-sm text-port-gray-600">{livraison.client}</p>
                  </div>
                </div>
                <div className="text-right">
                  <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                    livraison.status === 'Terminée' ? 'bg-atl-green-100 text-atl-green-800' :
                    livraison.status === 'En cours' ? 'bg-atl-blue-100 text-atl-blue-800' :
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {livraison.status}
                  </span>
                  <p className="text-sm text-port-gray-600 mt-1">{livraison.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard; 